"use client";

import { c as _c } from "react/compiler-runtime";
import { Container, Row, Col, Button } from "react-bootstrap";
import DotLoader from "../dotLoader/DotLoader";
import AppWalletCard from "./AppWalletCard";
import { CreateAppWalletModal } from "./AppWalletModal";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from "next/navigation";
import { useAppWallets } from "./AppWalletsContext";
import AppWalletsUnsupported from "./AppWalletsUnsupported";
export default function AppWallets() {
  const $ = _c(11);
  const {
    appWalletsSupported,
    fetchingAppWallets,
    appWallets
  } = useAppWallets();
  const router = useRouter();
  const [showCreateModal, setShowCreateModal] = useState(false);
  let t0;
  if ($[0] !== appWallets || $[1] !== fetchingAppWallets) {
    t0 = function printWallets() {
      if (fetchingAppWallets) {
        return <Col>Fetching wallets <DotLoader /></Col>;
      }
      if (appWallets.length === 0) {
        return <Col>No wallets found</Col>;
      }
      return appWallets.map(_temp);
    };
    $[0] = appWallets;
    $[1] = fetchingAppWallets;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const printWallets = t0;
  let t1;
  if ($[3] !== appWalletsSupported || $[4] !== printWallets || $[5] !== router || $[6] !== showCreateModal) {
    t1 = function printContent() {
      if (!appWalletsSupported) {
        return <AppWalletsUnsupported />;
      }
      return <><Row className="mt-4">{printWallets()}</Row><Row className="mt-4"><Col className="d-flex align-items-center gap-3"><CreateAppWalletModal show={showCreateModal} onHide={() => setShowCreateModal(false)} /><Button variant="primary" onClick={() => setShowCreateModal(true)} className="d-flex align-items-center gap-2"><FontAwesomeIcon icon={faPlusCircle} height={16} /> Create Wallet</Button><Button variant="success" onClick={() => router.push("/tools/app-wallets/import-wallet")} className="d-flex align-items-center gap-2"><FontAwesomeIcon icon={faPlusCircle} height={16} /> Import Wallet</Button></Col></Row></>;
    };
    $[3] = appWalletsSupported;
    $[4] = printWallets;
    $[5] = router;
    $[6] = showCreateModal;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const printContent = t1;
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Row><h1>App Wallets</h1></Row>;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== printContent) {
    t3 = <Container className="pt-4 pb-4">{t2}{printContent()}</Container>;
    $[9] = printContent;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(w) {
  return <Col xs={12} sm={6} md={4} key={w.address} className="pb-3"><AppWalletCard wallet={w} /></Col>;
}